<template>
  <div v-if="val" class="variation">
    <img :src="require(`@/assets/icons/${icon}.svg`)" alt="">
    <p :style="{color: color}">
      {{`(${formattedValue})`}}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    val: {
      type: Number,
      default: null
    }
  },
  computed: {
    icon() {
      if (this.val > 0) {
        return "occurence-hausse";
      } else if (this.val < 0) {
        return "occurence-baisse";
      } else {
        return "occurence-stable";
      }
    },
    color() {
      if (this.val > 0) {
        return "#77c311";
      } else if (this.val < 0) {
        return "#bf0b0b";
      } else {
        return "#c6c6c6";
      }
    },
    formattedValue() {
      return this.val < 0 ? this.val : "+" + this.val;
    }
  }
};
</script>

<style lang="scss">
.variation {
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 15px;
    height: auto;
    margin-right: 8px;
  }
}
</style>
